<template>
	<span class="command-btn-like-design">{{ commandBarShortcut }}</span>
</template>

<script>
import ExtensionCommunicationService from '@/utils/extension-communication-service';

export default {
	name: 'CommandSourtcutIndication',
	data() {
		return { commandBarShortcut: '' };
	},
	methods: {
		async getCommandBarShortcutFromExtension() {
			const commandBarShortcut = await ExtensionCommunicationService.getCommandBarShortcut();
			this.commandBarShortcut = commandBarShortcut?.commandBarShortcut?.shortcut;
		},
	},
	mounted() {
		this.getCommandBarShortcutFromExtension();
	},
};
</script>

<style scoped lang="scss">
.command-btn-like-design {
	letter-spacing: 4px;
}
</style>
